import {
  type ElementType,
  type PropsWithChildren,
  type ReactNode,
} from 'react';

import type { IntentProps } from '../../../../core/slots/Intent/Intent.js';
import { AriaLabelingProps } from '../../../../core/types/a11y-props.js';
import { DOMProps } from '../../../../core/types/dom.js';
import { Group } from '../../../../navigation/menu/Group.js';
import { Intent } from '../../../../navigation/menu/Intent.js';
import { Item } from '../../../../navigation/menu/Item.js';
import { ItemTooltip } from '../../../../navigation/menu/ItemTooltip.js';
import { Label } from '../../../../navigation/menu/Label.js';
import { Link, type MenuLinkProps } from '../../../../navigation/menu/Link.js';
import { Prefix } from '../../../../navigation/menu/Prefix.js';
import { Sub } from '../../../../navigation/menu/Sub.js';
import { SubContent } from '../../../../navigation/menu/SubContent.js';
import { SubTrigger } from '../../../../navigation/menu/SubTrigger.js';

/**
 * @public
 */
export type ChartSeriesActionProps = DOMProps &
  AriaLabelingProps & {
    children: ReactNode;
    /**
     * Disabled
     * @defaultValue false
     */
    disabled?: boolean;
  };

/**
 * ChartSeriesAction component
 */
const ChartSeriesActionRoot = ({
  children,
}: PropsWithChildren<ChartSeriesActionProps>) => (
  // oxlint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
);

ChartSeriesActionRoot['displayName'] = 'ChartSeriesAction';

/**
 * Slot component for chart series actions
 * @public
 */
export const ChartSeriesAction = Object.assign(ChartSeriesActionRoot, {
  Intent: ({ icon, ...props }: IntentProps) => (
    <Intent {...props}>
      {icon && <Prefix>{icon}</Prefix>}
      {props.children}
    </Intent>
  ),
  Item,
  ItemTooltip,
  Label,
  ItemIcon: Prefix,
  Group,
  Sub,
  SubTrigger,
  SubContent,
  Link: (props: MenuLinkProps<ElementType>) => (
    <Link data-link={true} {...props} />
  ),
});
